import { Injectable } from '@angular/core';
import {Observable, Subject, throwError} from 'rxjs';
import {delay, finalize, map} from 'rxjs/operators';

import {CONTENT_TYPE_JSON_UTF8, WORD_API_IN_URL, } from '../../defines/protocol';
import {HISTORY_KEY_HISTORY_WORD, SearchParam} from '../../defines/client.const';
import {ListLoader, ListLoader_NextList} from '../../interfaces/list-loader';
import {SimpleWord} from '../../models/simple-word.model';
import {SearchHistory} from '../../models/history.model';
import {ApiService} from '../api/api.service';


@Injectable({
  providedIn: 'root'
})
export class WordHistoryService implements ListLoader<SimpleWord> {

  private history: SearchHistory = null;

  constructor(
    private api: ApiService,
  ) {
    this.history = new SearchHistory({name: HISTORY_KEY_HISTORY_WORD});
  }

  public addHistory(id: string): void {
    if (!id) {
      console.error('WordHistoryService::addHistory() invalid id', id);
    }
    else {
      this.history.addItem(id);
    }
  }

  /******************************************************************************
   * ListLoader<Word> 구현부
   *****************************************************************************/

    // TODO: 일단 페이지 없이 모두 로딩한다. 나중에 페이지 로딩 추가해야 함.
  // private nextPage: number;
  private listWord: Array<SimpleWord>;
  private mapWord: Map<string, SimpleWord>;
  private load$: Observable<ListLoader_NextList<SimpleWord>> = null;

  public getList(): Array<SimpleWord> {
    return this.listWord;
  }

  public getCurCount(): number {
    console.log('WordHistoryService::getCurCount()');
    return (this.listWord && this.listWord.length) ?? 0;
  }

  public getTotalCount(): number {
    // console.log('WordHistoryService::getTotalCount()');
    return (this.history && this.history.list && this.history.size) ?? 0;
  }

  public IsComplete(): boolean {
    // console.log('WordHistoryService::IsComplete()',
    //   this.listWord?.length === this.history?.size, this.listWord?.length, this.history?.size,
    //   this.history);
    return this.history && (
      this.listWord && this.listWord.length === this.history.size ||
      this.history.empty()
    );
  }

  public IsLoading(): boolean {
    return this.load$ !== null;
  }

  public getById(id: string): SimpleWord {
    return this.mapWord.get(id) ?? null;
  }

  public ResetList(param?: SearchParam): void {
    // console.log('WordHistoryService::ResetList()', param, this);
    this.listWord = null;
    this.mapWord = null;

    // this.nextPage = 0;
    if (param && 'id' in param) {
      this.addHistory(param.id);
    }
  }

  public GetNextList(): Observable<ListLoader_NextList<SimpleWord>> {
    console.log('WordHistoryService::GetNextList()', this);
    // 이미 다 로딩 했는지 확인
    // if (this.history.listHistory.length < this.nextPage * HISTORY_PAGE_SIZE) {
    if (this.IsComplete()) {
      return throwError({message: 'already load all words in bookmark'});
    }
    else if (this.history && this.history.empty()) {
      // 이력이 없으면 서버에 요청하지 않고 처리한다.
      return new Observable<ListLoader_NextList<SimpleWord>>(observer => {
        observer.next({
          list: [],
          first: false,
        });
        observer.complete();
      }).pipe(delay(0));
    }

    if (this.load$) {
      return this.load$;
    }

    const url = WORD_API_IN_URL;
    return this.load$ = this.api.Post(url, {list: this.history.list}, null, CONTENT_TYPE_JSON_UTF8).pipe(
      finalize(() => {
        this.load$ = null;
      }),
      map((data: []) => {
        // if (this.nextPage === 0) {
        this.listWord = new Array<SimpleWord>();
        this.mapWord = new Map<string, SimpleWord>();
        // }

        const list = new Array<SimpleWord>();

        data.forEach(value => {
          const word = new SimpleWord(value);
          list.push(word);
          this.listWord.push(word);
          this.mapWord.set(word.id, word);
        });

        // return this.nextPage++ === 0;
        return {list, first:true};
      })
    );
  }
}
